export enum enumInsuranceShipmentType {
  FULL_CONTAINER = 1,
  COLOADING = 2,
  BREAKBULK = 3,
}
